import { makeStyles, tokens } from '@fluentui/react-components';

export const useValidatedBudgetInputStyles = makeStyles({
  root: {
    marginBottom: tokens.spacingVerticalMNudge,
  },
});
